import React from 'react';

/**
 * Sprint C — ProgressCard (Learn)
 * Three small stat tiles: courses started, courses completed, day streak.
 *
 * Renders only if there's at least 1 stat with a non-zero value.
 */
export const ProgressCard = ({ active = 0, completed = 0, streak = 0 }) => {
  if (!active && !completed && !streak) return null;

  const tiles = [
    { label: 'In progress', value: active, testid: 'progress-active' },
    { label: 'Completed', value: completed, testid: 'progress-completed' },
    { label: 'Day streak', value: streak, testid: 'progress-streak' },
  ].filter((t) => t.value || t.value === 0);

  return (
    <section data-testid="learn-progress" aria-labelledby="learn-progress-heading">
      <h3
        id="learn-progress-heading"
        className="text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-500 mb-3 px-1"
      >
        Your progress
      </h3>
      <div className="grid grid-cols-3 gap-2 sm:gap-3">
        {tiles.map((t) => (
          <div
            key={t.label}
            data-testid={t.testid}
            className="bg-white border border-[#E5DFD0] rounded-xl px-3 py-4 text-center"
          >
            <p className="font-serif text-[24px] sm:text-[28px] leading-none text-[#0E1C2E] tabular-nums">
              {t.value}
            </p>
            <p className="text-[10px] font-medium uppercase tracking-[0.16em] text-slate-400 mt-2">
              {t.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProgressCard;
